// Dynamic Stat Data for the About section
// 'category' must match keys in productsData.js
export const aboutAreasData = [
    { id: "imagenologia", category: "Imagenologia" },
    { id: "dermatologia", category: "Dermatologia" },
    { id: "cardiologia", category: "Cardiologia" },
    { id: "saludMental", category: "Salud Mental" },
    { id: "laboratorios", category: "Laboratorio Clinico" }
];